import axios from 'axios'
import store from '../store'

const baseURL = process.env.WEB_RPT_API

const webrptapi = {
  rpcId: 1,

  async post (url, data, options) {
    return axios.post(url, data, options).then(response => {
      return response
    }).catch((error) => {
      console.log('post exception', error)
      if (error.response) {
        return error.response
      } else if (error.request) {
        return error.message
      } else {
        return error.message
      }
    })
  },
  async makeAsyncRpcCall (data, asyncToken) {
    // console.log('makeAsyncRpcCall', asyncToken)
    // console.log('data', data)
    data.method = 'getAsyncProgress'
    data.params.asyncToken = asyncToken

    let timer = new Date()
    let timeout = 90
    let state = 'STARTING'

    let asyncProgress = null
    do {
      if (new Date() - timer > 1000) {
        timer = new Date()
        asyncProgress = await webrptapi.post(baseURL, data)
        state = asyncProgress.data.result.state
        timeout--
        store.commit('setWebRptState', state)
        // console.log('asyncProgress', state, asyncProgress, timeout)
      }
    } while (state !== 'FAILED' && state !== 'FINISHED' && timeout > 0)

    if (state === 'FINISHED') {
      data.method = 'getAsyncResult'
      asyncProgress = await webrptapi.post(baseURL, data)
    }

    return new Promise((resolve, reject) => {
      if (timeout <= 0) {
        resolve({
          error: {
            code: 'E00001',
            data: {
              name: 'Request timeout',
              message: 'E00001: timeout_connecting_server'
            }
          }
        })
      } else {
        resolve(asyncProgress)
      }
    })
  },
  async makeRpcCall (method, params) {
    var data = {
      jsonrpc: '2.0',
      id: webrptapi.rpcId++,
      method: method,
      params: params
    }
    // console.log('makeRpcCall', method, params)
    return webrptapi.post(baseURL, data).then(response => {
      if (response.data) {
        if (response.data.error) {
          return response.data
        } else if (response.data.result.asyncToken) {
          return webrptapi.makeAsyncRpcCall(data, response.data.result.asyncToken)
        } else {
          return response.data
        }
      } else {
        return {
          error: {
            code: 'E00001',
            name: 'Error',
            message: response
          }
        }
      }
    }).catch(ex => {
      clearTimeout(webrptapi.timeout)
      console.log('makeRpcCall exeption', ex)
    })
  },

  install (Vue) {
    Vue.prototype.$webrptapi = {
      makeRpcCall: this.makeRpcCall
    }
  }
}

export default webrptapi



// WEBPACK FOOTER //
// ./src/plugins/webrptapi.js